export default {
    i18nKey: 'persona1',
    firstName: 'Oliver',
    lastName: 'Benson',
    personaPrefix: 'OB_',
    image: '../assets/img/Persona1.jpg',
    index: 0,
    videoPrefix: 'OB-',
    personaDataAction: 'Onboarders'  
}